import styled from 'styled-components';
import dt from '../../../../../shared/theme';
import { DropdownContainer } from '../../../common/dropdown/styles';

const SDropdownContainer = styled(DropdownContainer)`
  padding: 8px 16px;

  &.active {
    background-color: #EFF1F6;
  }
`;

const FilterName = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  font-size: 21px;
  line-height: 120%;
`;

const SecondaryLabel = styled.div`
  color: #8EA3B5;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  margin-top: 32px;
`;

const InnerContainer = styled.div`
  width: ${props => (dt(props).theme.isMobile ? '100%' : '340px')};
  ${props => dt(props).theme.isLarge && `
    max-height: 256px;
    overflow-y: auto;
  `};
  border: 0.5px solid #D7DFE7;
  box-sizing: border-box;
  border-radius: 2px;
  margin-top: 16px;
  margin-bottom: 32px;
  padding: 8px;
`;

export {
  FilterName,
  InnerContainer,
  SDropdownContainer,
  SecondaryLabel,
};
